import script from "./TabsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsPage.vue?vue&type=script&setup=true&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=2a88c554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a88c554"]])

export default __exports__